export const MODE_LIST = 'list';
export const MODE_VIEW = 'view';